@import '../../../../../constants/spacing.module.less';

.settings-api-section-header {
  margin-bottom: @space-24;
  padding: @space-16 @space-16 @space-0;
}

.settings-api-selector-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.settings-api-selector-wrapper-with-banner {
  margin-bottom: @space-24;
}

.settings-api-selector {
  flex: 1;
  max-width: 224px;
}
